// TODO: Review AI Code for feature: System Landscape & Interactions Visualization
import { createFileRoute } from '@tanstack/react-router';
import { SystemLandscapePage } from '@/pages/systems/SystemLandscapePage';
import { createCaslGuard } from '@/lib/auth/permissionGuards';

export const Route = createFileRoute('/$slug/systems/landscape')({
  component: SystemLandscapePage,
  beforeLoad: createCaslGuard('SystemLandscape')
});
